/* eslint no-console:0 */

// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// https://babeljs.io/docs/en/next/babel-polyfill.html
// eslint-disable-next-line import/no-extraneous-dependencies
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// V1-COMPAT: RAILS_ASSET_URL global for the copied V2 trees (see the module).
import '../javascript/frontend/v2/rails_asset_url';

// KT: This allows us to use $ to reference jQuery from tests and in other places.
// See: https://github.com/webpack-contrib/expose-loader#examples
// require("expose-loader?exposes=$,jQuery!jquery");
// import $ from 'jquery';
// import moment from 'moment';
// global.$ = global.jQuery = $;
// window.$ = window.jQuery = $;

// import so as to configure properly before before jQuery's ready event fires https://github.com/ankane/ahoy.js/issues/9
import '../javascript/vahoy';
import '../javascript/ga_tracking';
import '../javascript/externalLinkWarning';

import Rails from 'rails-ujs';
import Turbolinks from 'turbolinks';

// V2-in-V1 messaging: repair back/forward when inbox URL changed but TL ignored popstate.
// Inbox path is hardcoded in that module — keep in sync with `config/routes.rb` `my_inbox_v2`.
import '../javascript/frontend/inbox_v2_turbolinks_popstate_bridge';

import 'bootstrap';
import 'popper.js';
import 'fullcalendar';

// this exposes timezoneHelpers as window.timezoneHelpers
import '../javascript/frontend/helpers/timezone_helpers';
import '../javascript/frontend/helpers/google_tag_manager_helpers';

import '../javascript/frontend/pages';
import '../javascript/frontend/config';
import '../javascript/frontend/vendor';

import '../javascript/frontend/v2/supabase_client';

// V1-COMPAT: second mount bridge, for the component trees copied from V2. It renders them with
// React 18 and its own `data-react18-class` marker, leaving the react_ujs bridge below untouched.
import '../javascript/frontend/v2/react18_mount';

Rails.start();
Turbolinks.start();

// KT: This allows us to use $ to reference jQuery from tests and in other places.
// See: https://github.com/webpack-contrib/expose-loader#examples
// eslint-disable-next-line import/no-webpack-loader-syntax
// require('expose-loader?$!jquery');

// V1-COMPAT: paths under react_components/ that belong to the react18 webpack layer.
//
// config/webpack/base.js puts those files in a layer where `react` resolves to React 18, and
// javascript/frontend/v2/react18_mount.js is what mounts them. The require.context below sweeps the
// whole directory, which would also make every one of them reachable by name from `react_component`
// -- one stray ERB call away from rendering React 18 code through React 16's ReactDOM.render.
// reactComponentsExcept below drops them from the react_ujs registry so that can't happen.
//
// These lists answer a narrower question than REACT18_LAYER_PATHS in config/webpack/base.js: not
// "which React does this file bind" but "may an ERB view mount this by name under React 16". So they
// are close to that list but not identical -- products/card/ is listed here in full while base.js
// claims only three of its files for the layer, because no ERB view mounts any card by name and some
// of them do contain React 18 children. Everything base.js claims must appear here.
const REACT18_TREES = [
  './companies/',
  './contact_details/',
  './experts/',
  './feeds/',
  './hashtags/',
  './media_items/',
  './media_outlets/',
  './media_profiles/',
  './pr_profiles/',
  './products/card/',
  './products/data/',
  './products/edit/',
  './products/reusable/',
  './products/show/',
  './profiles/',
  './quotes/',
  './source_directory/',
  './story_ideas/',
  './v2_host_glue/',
];

// Copied files that sit in a directory holding legacy V1 files too, so they can only be matched
// exactly. Their V1-native namesakes were renamed with a `_v1` suffix and are still registered.
const REACT18_FILES = [
  './AvatarProfileImage',
  './ColoredLogo',
  './MessageButton',
  './ProfileImage',
  './algolia_search/geo_search_by_place',
  './algolia_search/no_results_message',
  './algolia_search/smart_snippet',
  './confirm_modal',
  './error_boundary',
  './hashtags',
  './hooks/use_infinite_scroll',
  './loading_image',
  './products/ProductSearch',
  './products/RequestSampleButton',
  './products/product_top_level_show',
  './products/requestSample',
  './views_shared_copies/components/AvatarWithLabel',
  './views_shared_copies/components/ImageCropped',
];

// react_ujs asks the context for extensionless requests ('./avatar/avatar') while the context's own
// keys carry extensions, so both forms have to compare equal.
function isReact18Path(request) {
  const withoutExtension = request.replace(/\.jsx?$/, '');

  return REACT18_TREES.some((tree) => withoutExtension.startsWith(tree))
    || REACT18_FILES.includes(withoutExtension);
}

function reactComponentsExcept(context, excluded) {
  const registry = (request) => {
    if (excluded(request)) {
      throw new Error(`'${request}' renders under React 18. Mount it with react18_component.`);
    }
    return context(request);
  };

  registry.keys = () => context.keys().filter((key) => !excluded(key));
  registry.resolve = (request) => context.resolve(request);
  registry.id = context.id;

  return registry;
}

// Exclude __tests__ directories and test-helper files.
const componentRequireContext = require.context('react_components', true, /^((?!__tests__|test-helpers).)*$/);
const ReactRailsUJS = require('react_ujs');

// eslint-disable-next-line react-hooks/rules-of-hooks
ReactRailsUJS.useContext(reactComponentsExcept(componentRequireContext, isReact18Path));

// https://trello.com/c/06ubrxae/1284-month-error-page-suspect-incomplete-implementation-of-custom-error-pages-is-causing-error-pages-to-not-render-when-navigated-to
// Monkey patch Turbolinks to render 403, 404 & 500 normally
// See https://github.com/turbolinks/turbolinks/issues/179
window.Turbolinks.HttpRequest.prototype.requestLoaded = function requestLoaded() {
  return this.endRequest(() => {
    const code = this.xhr.status;
    if ((code >= 200 && code < 300)
        || code === 403 || code === 404 || code === 500) {
      this.delegate.requestCompletedWithResponse(
        this.xhr.responseText,
        this.xhr.getResponseHeader('Turbolinks-Location'),
      );
    } else {
      this.failed = true;
      this.delegate.requestFailedWithStatusCode(code, this.xhr.responseText);
    }
  });
};

document.addEventListener('turbolinks:load', () => {
  ReactRailsUJS.mountComponents();
  ReactRailsUJS.detectEvents();
});
